import i18n from '@plugins/i18n';

import { HoldingCollection, Holding } from '@/models';

export class HoldingPmiOpenCollection extends HoldingCollection {
    static type = 'HoldingPmiOpenCollection';
    static endpoint = Holding.api.byTranche;

    get headers() {
        let headers = [
            this.createHeader('fund_name', i18n.t('fund'), {
                width: '18rem',
                minWidth: '18rem',
                sortable: false
            }),
            this.createHeader('name', i18n.t('name'), {
                width: '14rem',
                minWidth: '14rem',
                transform: data => {
                    if (data.item?.multi_investment === true) {
                        return i18n.t('co_invest');
                    }
                    return data.item.name;
                },
                sortable: false
            }),
            this.createHeader('pending_allotment', i18n.t('pending_allotment'), {
                filterable: {
                    operators: this.getOperators(['eq'])
                },
                format: 'boolean',
                active: false
            }),
            this.createHeader('gross_investment_amount', i18n.t('gross_investment_value'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '10rem',
                sortable: false
            }),
            this.createHeader('invested_amount', i18n.t('invested_amount'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                sortable: false
            }),
            this.createHeader('uninvested_capital', i18n.t('fund_cash_balance'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                sortable: false
            }),
            this.createHeader('invested_on', i18n.t('application_on'), {
                format: 'date',
                width: '8rem',
                sortable: false
            }),
            this.createHeader('current_value', i18n.t('current_value'), {
                column: 'current_value',
                format: 'money',
                formatOptions: super.money_format_options,
                width: '9rem',
                sortable: false
            }),
            this.createHeader('total_exits', i18n.t('total_exits'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                sortable: false
            }),
            this.createHeader('total_return', i18n.t('total_return'), {
                column: 'total_return',
                format: 'money',
                formatOptions: super.money_format_options,
                width: '9rem',
                sortable: false
            }),
            this.createHeader('total_return_moic', i18n.t('total_return_moic'), {
                column: 'total_return_moic',
                format: 'number',
                formatOptions: {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                },
                append: 'X',
                width: '9.2rem',
                sortable: false
            }),
            this.createHeader('total_return_percentage', i18n.t('total_return_percentage'), {
                column: 'total_return_percentage',
                format: 'percentage',
                formatOptions: this.percentage_format_options,
                width: '9.2rem',
                sortable: false
            }),
            this.createHeader('total_dividends', i18n.t('dividends'), {
                sortable: true,
                format: 'money',
                formatOptions: super.money_format_options,
                width: '9rem'
            })
        ];

        return headers;
    }

    get default_headers() {
        return [
            'fund_name',
            'name',
            'gross_investment_amount',
            'invested_amount',
            'uninvested_capital',
            'application_on',
            'total_exits',
            'current_value',
            'total_return',
            'total_return_moic',
            'total_return_percentage'
        ];
    }

    get pdf_headers() {
        return [
            'fund_name',
            'name',
            'gross_investment_amount',
            'invested_amount',
            'uninvested_capital',
            'application_on',
            'total_exits',
            'current_value',
            'total_return',
            'total_return_moic',
            'total_return_percentage',
            'total_dividends'
        ];
    }

    get xlsx_headers() {
        return [
            'fund_name',
            'name',
            'gross_investment_amount',
            'invested_amount',
            'uninvested_capital',
            'application_on',
            'total_exits',
            'current_value',
            'total_return',
            'total_return_moic',
            'total_return_percentage',
            'total_dividends'
        ];
    }

    get preset_filters() {
        let filters = {
            ...super.preset_filters,
            tax_status: this.filterOperator('is') + ':pmi-open'
        };

        if (this.show_closed_positions) {
            filters.show_closed = true;
        }

        return filters;
    }
}

export default HoldingPmiOpenCollection;
